<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon">
    <mat-icon class="material-symbols-outlined">payments</mat-icon>
  </div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Excluir financeiro</h2>
    <span class="modal-subtitle">NF-e {{ data.numeroNota }}</span>
  </div>
</div>

<mat-dialog-content class="modal-content">
  <p>A conta a pagar desta nota será excluída. Se alguma parcela já tiver pagamento, estorne o pagamento no Finanças antes de excluir.</p>
  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Justificativa</mat-label>
    <textarea matInput rows="4" maxlength="500" [formControl]="justificativa" placeholder="Informe o motivo da exclusão"></textarea>
    <mat-hint align="end">{{ justificativa.value.length }}/500</mat-hint>
    <mat-error *ngIf="justificativa.invalid && justificativa.touched">Informe ao menos 10 caracteres.</mat-error>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-footer">
  <button mat-stroked-button type="button" class="btn-secondary" (click)="cancelar()">Cancelar</button>
  <button mat-flat-button class="btn-primary" type="button" (click)="confirmar()">Confirmar exclusão</button>
</mat-dialog-actions>
